import { Network } from "../common/Network";
export var MapApi;
(function (MapApi) {
    async function getMapboxToken(token) {
        return await Network.plusGet(`mapbox-token`, token);
    }
    MapApi.getMapboxToken = getMapboxToken;
})(MapApi || (MapApi = {}));
